import React from 'react';
import './Modal_1.css';

import x from "../../../../asset/x.svg";

const Modal1 = ({ image, onClose }) => {
    return (
      <div className="drawing-modal-container" onClick={onClose}>
        <div className="drawing-modal-upper">
            <img
                src={x}
                alt={"x"}
                onClick={onClose}
                className="drawing-modal-upper-x"
                style={{
                    width: "auto",
                    height: "20px",
                    margin: "2%"
                }}
            />
        </div>
        <div className="drawing-modal-lower" onClick={(e) => e.stopPropagation()}>
          <img src={image} alt={"drawing-modal-image"} className="drawing-modal-image" />
        </div>
        <div className="drawing-modal-bottom">
        </div>
      </div>
    );
  };
  
  export default Modal1;